module.exports = "/_next/static/images/nflWhiteIcon@3x-290a3c19c98c31875e7acfb0ce97ef69.png";